export default __webpack_public_path__ + "static/media/AD_icon.1dcac4d2.svg";